import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatLegacyMenuTrigger } from '@angular/material/legacy-menu';
import { User } from '@mode/algolia/contract';
import { Emailable } from '@mode/shared/schedules/contract';
import { HelpDocsService } from '@mode/shared/util-js';
import { map } from 'rxjs';

@Component({
  selector: 'mode-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchComponent {
  @Input() searchResults: User[] = [];
  @Input() authorizedDomains: string[] = [];
  @Input() externalSharingEnabled = false;
  @Output() searchInputChange = new EventEmitter<string>();
  @Output() searchResultClicked = new EventEmitter<Emailable>();

  @ViewChild(MatLegacyMenuTrigger) menuTrigger!: MatLegacyMenuTrigger;

  public searchText = '';

  constructor(public helpDocs: HelpDocsService) {}

  showExternalDomainError$ = this.searchInputChange.pipe(
    map((searchText) => {
      const searchTextDomain = searchText.split('@')[1];
      return (
        !this.externalSharingEnabled &&
        searchTextDomain?.length > 0 &&
        !this.authorizedDomains.includes(searchTextDomain)
      );
    })
  );

  suggestedEmails$ = this.searchInputChange.pipe(
    map((searchText: string) => {
      const usernameRegex = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+$/i;
      const sanitizedSearchText = searchText.trim();
      const username = sanitizedSearchText.split('@')[0];

      if (!usernameRegex.test(username)) {
        return [];
      }
      return this.authorizedDomains.map((eachDomain) => `${username}@${eachDomain}`);
    })
  );

  externalEmail$ = this.searchInputChange.pipe(
    map((searchText: string) => {
      const emailRegex =
        /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])+(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+$/i;
      const sanitizedSearchText = searchText.trim();

      if (!this.externalSharingEnabled || !emailRegex.test(sanitizedSearchText)) {
        return '';
      }
      return sanitizedSearchText;
    })
  );

  inputChange(currentInputValue: string) {
    this.searchInputChange.emit(currentInputValue);
    this.searchText = currentInputValue;
    if (!this.menuTrigger.menuOpen) {
      this.menuTrigger.openMenu();
    }
  }

  userSelected(selection: string | User) {
    this.searchText = '';
    this.searchResultClicked.emit(typeof selection === 'string' ? { email: selection } : selection);
  }
}
